import { useTranslation } from 'react-i18next';

import {
  AUTH_ILLUSTRATIONS_COMPONENTS,
  Typography,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';

import { MainWrapper, ThanksContainer } from '../../questionnaire-page.styles';

const QuestionnaireThank = () => {
  const { t } = useTranslation(['employee']);

  const Illustration = AUTH_ILLUSTRATIONS_COMPONENTS.thanks;
  return (
    <MainWrapper>
      <ThanksContainer>
        <div>
          <Illustration />
          <Typography weight="bold" size={TYPOGRAPHY_SIZE.large}>
            {t('employee:questionnaire.labels.thanks.title')}
          </Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey} className={'subtitle'}>
            {t('employee:questionnaire.labels.thanks.subtitle')}
          </Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t('employee:questionnaire.labels.thanks.description')}
          </Typography>
        </div>
      </ThanksContainer>
    </MainWrapper>
  );
};

export default QuestionnaireThank;
